import CategoryWarehouseList from '@/components/CategoryWarehouse/CategoryWarehouseList'

let CategoryWarehouseRouter = [{
  path: '/category-warehouse',
  name: 'CategoryWarehouseList',
  component: CategoryWarehouseList,
  meta: {
    title: 'Visibilité entrepôt par catégorie',
    requiresAuth: true,
    authorizations: ['category-warehouse_index', 'desktop_access']
  }
}]

export default CategoryWarehouseRouter



// WEBPACK FOOTER //
// ./src/components/CategoryWarehouse/router.js